import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Loader2 } from 'lucide-react';
import { parseApiResponse } from '../utils/apiErrors';
import { API } from '../config/apiBase';

export default function AuthCallback() {
    const navigate = useNavigate();
    const { setUser } = useAuth();
    const hasProcessed = useRef(false);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const processAuth = async () => {
            try {
                const params = new URLSearchParams(window.location.search);
                const code = params.get('code');
                const state = params.get('state');

                if (!code) {
                    navigate('/login');
                    return;
                }

                const redirectUri = window.location.origin + '/auth/callback';
                const isFacebook = state === 'facebook';
                const endpoint = isFacebook ? `${API}/auth/facebook` : `${API}/auth/google`;

                const response = await fetch(endpoint, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    credentials: 'include',
                    body: JSON.stringify({ code, redirect_uri: redirectUri })
                });

                const { data, error } = await parseApiResponse(response, 'login');
                if (error) throw new Error(error.message);

                if (data.token) {
                    localStorage.setItem('token', data.token);
                }
                setUser(data.user || data);
                navigate('/', { replace: true });
            } catch (error) {
                console.error('Auth callback error:', error);
                navigate('/login');
            }
        };

        processAuth();
    }, [navigate, setUser]);

    return (
        <div className="min-h-screen flex flex-col items-center justify-center" style={{ background: 'var(--bg)' }} data-testid="auth-callback">
            <Loader2 className="w-12 h-12 text-gold-500 animate-spin mb-4" />
            <p style={{ color: 'var(--muted-2)' }}>Autenticando...</p>
        </div>
    );
}
